"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.success = exports.searchIcon = exports.locationIcon = exports.information = exports.eyeIconVisible = exports.eyeIconHidden = exports.error = exports.ellipsis = exports.deleteIcon = exports.close = exports.box = exports.arrowIconWhite = exports.arrowIcon = exports.arrow = exports.SearchIcon = exports.CloseIcon = exports.CheckSmall = exports.CheckLarge = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var eyeIconHidden = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "eye\u0627",
  width: "22.736",
  height: "14.491",
  viewBox: "0 0 22.736 14.491"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_812",
  "data-name": "Group 812",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_811",
  "data-name": "Group 811",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_839",
  "data-name": "Path 839",
  d: "M22.591,99.638c-.2-.278-5.043-6.8-11.223-6.8S.347,99.36.144,99.638a.75.75,0,0,0,0,.885c.2.278,5.043,6.8,11.223,6.8s11.02-6.525,11.223-6.8A.749.749,0,0,0,22.591,99.638Zm-11.223,6.189c-4.553,0-8.5-4.331-9.663-5.747,1.166-1.417,5.1-5.746,9.663-5.746s8.5,4.33,9.663,5.747C19.865,101.5,15.93,105.827,11.368,105.827Z",
  transform: "translate(0 -92.835)",
  fill: "#727272"
}))), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_814",
  "data-name": "Group 814",
  transform: "translate(6.871 2.749)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_813",
  "data-name": "Group 813",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_840",
  "data-name": "Path 840",
  d: "M159.219,154.725a4.5,4.5,0,1,0,4.5,4.5A4.5,4.5,0,0,0,159.219,154.725Zm0,7.5a3,3,0,1,1,3-3A3,3,0,0,1,159.219,162.22Z",
  transform: "translate(-154.722 -154.725)",
  fill: "#727272"
}))));

exports.eyeIconHidden = eyeIconHidden;

var eyeIconVisible = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "22.736",
  height: "16.546",
  viewBox: "0 0 22.736 16.546"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "eye",
  transform: "translate(0 0.418)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_812",
  "data-name": "Group 812",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_811",
  "data-name": "Group 811",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_839",
  "data-name": "Path 839",
  d: "M22.591,99.638c-.2-.278-5.043-6.8-11.223-6.8S.347,99.36.144,99.638a.75.75,0,0,0,0,.885c.2.278,5.043,6.8,11.223,6.8s11.02-6.525,11.223-6.8A.749.749,0,0,0,22.591,99.638Zm-11.223,6.189c-4.553,0-8.5-4.331-9.663-5.747,1.166-1.417,5.1-5.746,9.663-5.746s8.5,4.33,9.663,5.747C19.865,101.5,15.93,105.827,11.368,105.827Z",
  transform: "translate(0 -92.835)",
  fill: "#727272"
}))), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_814",
  "data-name": "Group 814",
  transform: "translate(6.871 2.749)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_813",
  "data-name": "Group 813",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_840",
  "data-name": "Path 840",
  d: "M159.219,154.725a4.5,4.5,0,1,0,4.5,4.5A4.5,4.5,0,0,0,159.219,154.725Zm0,7.5a3,3,0,1,1,3-3A3,3,0,0,1,159.219,162.22Z",
  transform: "translate(-154.722 -154.725)",
  fill: "#727272"
}))), /*#__PURE__*/_react["default"].createElement("line", {
  id: "Line_130",
  "data-name": "Line 130",
  x1: "14",
  y2: "14",
  transform: "translate(4.557 0.855)",
  fill: "none",
  stroke: "#707070",
  strokeLinecap: "round",
  strokeWidth: "1.8"
})));

exports.eyeIconVisible = eyeIconVisible;

var arrow = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "7.445",
  height: "13.06",
  viewBox: "0 0 7.445 13.06"
}, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fill: "#333",
  d: "M104.315 7.176L98.7 12.792a.915.915 0 1 1-1.294-1.292l4.969-4.969-4.969-4.97A.915.915 0 0 1 98.7.268l5.616 5.616a.914.914 0 0 1 0 1.293z",
  transform: "translate(-97.139)"
})));

exports.arrow = arrow;

var searchIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "loupe",
  transform: "translate(-1 -1.004)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "loupe_1_",
  transform: "translate(1 1.004)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_325"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_324"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_555",
  d: "M9.688 0a9.688 9.688 0 1 0 9.688 9.688A9.7 9.7 0 0 0 9.688 0zm0 17.588a7.9 7.9 0 1 1 7.9-7.9 7.909 7.909 0 0 1-7.9 7.9z",
  style: {
    fill: "#727272"
  }
}))), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_327",
  transform: "translate(15.084 15.084)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_326"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_556",
  d: "M357.7 356.435l-5.127-5.127a.894.894 0 0 0-1.265 1.265l5.127 5.127a.894.894 0 0 0 1.265-1.265z",
  transform: "translate(-351.046 -351.046)",
  style: {
    fill: "#727272"
  }
}))))));

exports.searchIcon = searchIcon;

var CheckLarge = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11.477",
  height: "7.905",
  viewBox: "0 0 11.477 7.905"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "check",
  transform: "translate(0 -53)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_278",
  "data-name": "Group 278",
  transform: "translate(0 53)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_541",
  fill: "#7300a8",
  d: "M11.311 54.18a.59.59 0 0 0-.835-.015l-.015.015-6.335 6.3L1 57.355a.59.59 0 0 0-.835.835l3.543 3.543a.59.59 0 0 0 .835 0l6.757-6.718a.591.591 0 0 0 .011-.835z",
  "data-name": "Path 541",
  transform: "translate(0 -54)"
}))));

exports.CheckLarge = CheckLarge;

var CheckSmall = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10.034",
  height: "6.912",
  viewBox: "0 0 10.034 6.912"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "check",
  transform: "translate(0 -53)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_278",
  "data-name": "Group 278",
  transform: "translate(0 50.096)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_541",
  fill: "#7300a8",
  d: "M9.889 54.158a.516.516 0 0 0-.73-.013l-.013.013-5.538 5.508-2.733-2.733a.516.516 0 0 0-.73.73l3.1 3.1a.516.516 0 0 0 .73 0l5.9-5.873a.516.516 0 0 0 .014-.732z",
  "data-name": "Path 541",
  transform: "translate(0 -51.096)"
}))));

exports.CheckSmall = CheckSmall;

var SearchIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 22 22"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "loupe",
  transform: "translate(-1 -1.004)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "loupe_1_",
  "data-name": "loupe (1)",
  transform: "translate(1 1.004)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_325",
  "data-name": "Group 325"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_324",
  "data-name": "Group 324"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_555",
  d: "M9.688 0a9.688 9.688 0 1 0 9.688 9.688A9.7 9.7 0 0 0 9.688 0zm0 17.588a7.9 7.9 0 1 1 7.9-7.9 7.909 7.909 0 0 1-7.9 7.9z",
  className: "cls-1",
  "data-name": "Path 555",
  fill: "#4b4b4b"
}))), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_327",
  "data-name": "Group 327",
  transform: "translate(15.084 15.084)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_326",
  "data-name": "Group 326"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_556",
  d: "M357.7 356.435l-5.127-5.127a.894.894 0 0 0-1.265 1.265l5.127 5.127a.894.894 0 0 0 1.265-1.265z",
  className: "cls-1",
  "data-name": "Path 556",
  transform: "translate(-351.046 -351.046)",
  fill: "#4b4b4b"
}))))));

exports.SearchIcon = SearchIcon;

var warning = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25.596",
  height: "22.295",
  viewBox: "0 0 25.596 22.295"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "warning",
  transform: "translate(0 0.001)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_908",
  "data-name": "Group 908",
  transform: "translate(0 -0.001)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_907",
  "data-name": "Group 907",
  transform: "translate(0 0)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_896",
  "data-name": "Path 896",
  d: "M25.3,49.645a1,1,0,1,0-1.857.741,2.137,2.137,0,0,1-.228,1.992,2.109,2.109,0,0,1-1.772.937H4.152a2.148,2.148,0,0,1-1.825-3.277l8.647-14a2.144,2.144,0,0,1,3.649,0l6.4,10.355a1,1,0,0,0,1.7-1.051l-6.4-10.355a4.143,4.143,0,0,0-7.051,0l-8.647,14a4.147,4.147,0,0,0,3.526,6.327H21.447A4.081,4.081,0,0,0,24.874,53.5,4.135,4.135,0,0,0,25.3,49.645Z",
  transform: "translate(0 -33.02)",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_897",
  "data-name": "Path 897",
  d: "M237.046,361.991a1,1,0,0,0,0-2h0a1,1,0,0,0,0,2Z",
  transform: "translate(-224.246 -343.645)",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_898",
  "data-name": "Path 898",
  d: "M238.042,151.358V144.01a1,1,0,1,0-2,0v7.348a1,1,0,1,0,2,0Z",
  transform: "translate(-224.242 -137.511)",
  fill: "#fff"
})))));

exports.warning = warning;

var error = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "close",
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.307",
  height: "26.307",
  viewBox: "0 0 26.307 26.307"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_886",
  "data-name": "Path 886",
  d: "M13.153,26.307A13.153,13.153,0,1,1,26.307,13.153,13.168,13.168,0,0,1,13.153,26.307Zm0-24.428A11.274,11.274,0,1,0,24.428,13.153,11.287,11.287,0,0,0,13.153,1.879Zm0,0",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_887",
  "data-name": "Path 887",
  d: "M156.622,157.562a.936.936,0,0,1-.664-.275l-9.4-9.4a.939.939,0,0,1,1.328-1.328l9.4,9.4a.94.94,0,0,1-.664,1.6Zm0,0",
  transform: "translate(-138.771 -138.772)",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_888",
  "data-name": "Path 888",
  d: "M147.225,157.561a.94.94,0,0,1-.664-1.6l9.4-9.4a.939.939,0,0,1,1.328,1.328l-9.4,9.4A.936.936,0,0,1,147.225,157.561Zm0,0",
  transform: "translate(-138.77 -138.77)",
  fill: "#fff"
}));

exports.error = error;

var information = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "alert",
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.307",
  height: "26.307",
  viewBox: "0 0 26.307 26.307"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_889",
  "data-name": "Path 889",
  d: "M13.153,0A13.153,13.153,0,1,0,26.307,13.153,13.168,13.168,0,0,0,13.153,0Zm0,24.428A11.274,11.274,0,1,1,24.428,13.153,11.287,11.287,0,0,1,13.153,24.428Zm0,0",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_890",
  "data-name": "Path 890",
  d: "M238.654,384.016a.943.943,0,0,0-.667,1.606.942.942,0,0,0,1.024.2,1.08,1.08,0,0,0,.31-.2.953.953,0,0,0,0-1.334,1.1,1.1,0,0,0-.31-.2A.939.939,0,0,0,238.654,384.016Zm0,0",
  transform: "translate(-225.501 -379.318)",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_891",
  "data-name": "Path 891",
  d: "M238.654,109.715a.94.94,0,0,0-.939.939v10.335a.939.939,0,1,0,1.879,0V110.654A.94.94,0,0,0,238.654,109.715Zm0,0",
  transform: "translate(-225.501 -101.259)",
  fill: "#fff"
}));

exports.information = information;

var success = /*#__PURE__*/_react["default"].createElement("svg", {
  id: "Group_912",
  "data-name": "Group 912",
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.153",
  height: "26.153",
  viewBox: "0 0 26.153 26.153"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_904",
  "data-name": "Group 904",
  transform: "translate(6.211 3.285)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_903",
  "data-name": "Group 903"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_894",
  "data-name": "Path 894",
  d: "M140.763,64.617a.985.985,0,0,0-1.394,0L127.545,76.409l-4.266-4.634a.986.986,0,1,0-1.45,1.335L126.79,78.5a.984.984,0,0,0,.7.318h.021a.987.987,0,0,0,.7-.287l12.551-12.518A.986.986,0,0,0,140.763,64.617Z",
  transform: "translate(-121.568 -64.327)",
  fill: "#fff"
}))), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_906",
  "data-name": "Group 906"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_905",
  "data-name": "Group 905"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_895",
  "data-name": "Path 895",
  d: "M25.168,12.091a.986.986,0,0,0-.986.986A11.105,11.105,0,1,1,13.077,1.971a.986.986,0,1,0,0-1.971A13.077,13.077,0,1,0,26.153,13.077.986.986,0,0,0,25.168,12.091Z",
  fill: "#fff"
}))));

exports.success = success;

var close = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.356",
  height: "14.356",
  viewBox: "0 0 14.356 14.356"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "close_1_",
  "data-name": "close (1)",
  d: "M8.493,7.314l5.59-5.59A.93.93,0,0,0,12.768.409L7.178,6,1.588.409A.93.93,0,0,0,.273,1.724l5.59,5.59L.273,12.9a.93.93,0,1,0,1.315,1.315l5.59-5.59,5.59,5.59A.93.93,0,0,0,14.083,12.9Zm0,0",
  transform: "translate(0 -0.136)",
  fill: "#727272"
}));

exports.close = close;

var box = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "319.694",
  height: "auto",
  viewBox: "0 0 319.694 229.977"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "box_2_",
  transform: "translate(72.348 .057)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_344",
  d: "M264.474 0H55.1L0 63.422v166.484h319.573V63.422z",
  fill: "#e5a259",
  transform: "translate(-72.227 .014)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_345",
  fill: "#cd7900",
  d: "M55.1 0L0 63.422h319.573L264.474 0z",
  transform: "translate(-72.348 .014)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_346",
  d: "M62.639 65.856L46.783 50 30.928 65.856 23 57.928v23.783h47.567V57.928z",
  fill: "#ffc800",
  transform: "translate(41.106 148.209)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Rectangle_879",
  fill: "#ffce8e",
  d: "M0 0H72V62H0z",
  transform: "translate(51.625 119.96)"
}), /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_111",
  transform: "translate(64.106 130.822)"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_347",
  d: "M50.747 41H26.964a3.964 3.964 0 0 0 0 7.928h23.783a3.964 3.964 0 0 0 0-7.928z",
  fill: "#e5a259",
  transform: "translate(-23 -9.289)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_348",
  d: "M39.928 41h-3.964a3.964 3.964 0 1 0 0 7.928h3.964a3.964 3.964 0 0 0 0-7.928z",
  fill: "#e5a259",
  transform: "translate(3.675 -9.289)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_349",
  d: "M30.964 40.928h23.783a3.964 3.964 0 0 0 0-7.928H30.964a3.964 3.964 0 1 0 0 7.928z",
  fill: "#e5a259",
  transform: "translate(-11.144 -33)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_350",
  d: "M42.892 37h-7.928a3.964 3.964 0 0 0 0 7.928h7.928a3.964 3.964 0 0 0 0-7.928z",
  fill: "#e5a259",
  transform: "translate(.711 -21.144)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_351",
  d: "M26.964 44.928h7.928a3.964 3.964 0 0 0 0-7.928h-7.928a3.964 3.964 0 1 0 0 7.928z",
  fill: "#e5a259",
  transform: "translate(-23 -21.144)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_352",
  d: "M26.964 40.928h3.964a3.964 3.964 0 1 0 0-7.928h-3.964a3.964 3.964 0 1 0 0 7.928z",
  fill: "#e5a259",
  transform: "translate(-23 -33)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_353",
  d: "M29.15 38.112a4.02 4.02 0 0 0 0 5.629 3.98 3.98 0 0 0 5.629-5.629 4.15 4.15 0 0 0-5.629 0z",
  fill: "#e5a259",
  transform: "translate(-8.18 -21.107)"
})), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_547",
  fill: "#ffb100",
  d: "M-.234.193l47.7.225-.153 65.448-47.489-.225z",
  transform: "translate(64.342 -.25)"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_354",
  d: "M30.914 35.82l15.828 15.855L62.57 35.82l7.914 7.928V16H23v27.747z",
  fill: "#ffc800",
  transform: "translate(41.106 47.436)"
})));

exports.box = box;

var arrowIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.33",
  height: "49.009",
  viewBox: "0 0 14.33 49.009"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fill: "#727272",
  d: "M9.082 6.658A1.357 1.357 0 1 0 11 4.739L6.659.4A1.356 1.356 0 0 0 4.812.33C4.755.379 5.062.075.4 4.739a1.357 1.357 0 1 0 1.917 1.919l2.026-2.026 1.242 39.333-2.026-2.026a1.357 1.357 0 0 0-1.919 1.919l4.335 4.335A1.358 1.358 0 0 0 7.9 48.2l4.342-4.342a1.357 1.357 0 1 0-1.919-1.919L8.3 43.965 7.057 4.632z",
  transform: "rotate(2 .848 48.582)"
}));

exports.arrowIcon = arrowIcon;

var arrowIconWhite = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.33",
  height: "49.009",
  viewBox: "0 0 14.33 49.009"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fill: "#f7f7f7",
  d: "M9.082 6.658A1.357 1.357 0 1 0 11 4.739L6.659.4A1.356 1.356 0 0 0 4.812.33C4.755.379 5.062.075.4 4.739a1.357 1.357 0 1 0 1.917 1.919l2.026-2.026 1.242 39.333-2.026-2.026a1.357 1.357 0 0 0-1.919 1.919l4.335 4.335A1.358 1.358 0 0 0 7.9 48.2l4.342-4.342a1.357 1.357 0 1 0-1.919-1.919L8.3 43.965 7.057 4.632z",
  transform: "rotate(2 .848 48.582)"
}));

exports.arrowIconWhite = arrowIconWhite;

var locationIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.998",
  height: "20",
  viewBox: "0 0 19.998 20"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_958",
  "data-name": "Path 958",
  fill: "#727272",
  d: "M137.136,263.634h-.779a8.44,8.44,0,0,0-7.658-7.624V255.2a.781.781,0,1,0-1.563,0v.82a8.44,8.44,0,0,0-7.581,7.617H118.7a.781.781,0,1,0,0,1.563h.856a8.441,8.441,0,0,0,7.582,7.617v.82a.781.781,0,1,0,1.563,0v-.814a8.441,8.441,0,0,0,3.307-1,.781.781,0,0,0-.751-1.37,6.864,6.864,0,0,1-2.556.8v-1.6a.781.781,0,1,0-1.563,0h0v1.592a6.888,6.888,0,0,1-6.01-6.045h1.558a.781.781,0,1,0,0-1.563h-1.558a6.888,6.888,0,0,1,6.01-6.045v1.592a.781.781,0,1,0,1.563,0v-1.6a6.889,6.889,0,0,1,6.089,6.054h-1.636a.781.781,0,1,0,0,1.563h1.634a6.882,6.882,0,0,1-.925,2.725.781.781,0,0,0,1.32.837l.021-.037a8.433,8.433,0,0,0,1.154-3.525h.779a.781.781,0,1,0,0-1.563Z",
  transform: "translate(-117.917 -254.415)"
}));

exports.locationIcon = locationIcon;

var deleteIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "15",
  height: "15.104",
  viewBox: "0 0 15 15.104"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "delete",
  transform: "translate(16521 -5996)"
}, /*#__PURE__*/_react["default"].createElement("rect", {
  id: "Rectangle_959",
  "data-name": "Rectangle 959",
  width: "15",
  height: "15",
  transform: "translate(-16521 5996)",
  fill: "none"
}), /*#__PURE__*/_react["default"].createElement("g", {
  id: "trash",
  transform: "translate(-16520.293 5996.053)"
}, /*#__PURE__*/_react["default"].createElement("g", {
  id: "Group_332",
  "data-name": "Group 332"
}, /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_557",
  "data-name": "Path 557",
  d: "M39.835,2.166H36.712V1.655A1.655,1.655,0,0,0,35.06,0H32.091A1.655,1.655,0,0,0,30.44,1.655v.511H27.317a.418.418,0,0,0,0,.835h.753v9.815A2.234,2.234,0,0,0,30.3,15.051h6.555a2.234,2.234,0,0,0,2.228-2.234V3h.753a.418.418,0,0,0,0-.835Zm-8.562-.511a.82.82,0,0,1,.818-.82H35.06a.82.82,0,0,1,.818.82v.511h-4.6Zm6.975,11.161a1.4,1.4,0,0,1-1.4,1.4H30.3a1.4,1.4,0,0,1-1.4-1.4V3h9.349v9.815Z",
  transform: "translate(-26.9)",
  fill: "#333333"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_558",
  "data-name": "Path 558",
  d: "M230.117,153.619a.415.415,0,0,0,.417-.418v-7.383a.417.417,0,1,0-.833,0v7.38A.418.418,0,0,0,230.117,153.619Z",
  transform: "translate(-223.441 -140.901)",
  fill: "#333333"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_559",
  "data-name": "Path 559",
  d: "M142.017,167.5a.415.415,0,0,0,.417-.418v-6.464a.417.417,0,1,0-.833,0v6.464A.417.417,0,0,0,142.017,167.5Z",
  transform: "translate(-138.06 -155.243)",
  fill: "#333333"
}), /*#__PURE__*/_react["default"].createElement("path", {
  id: "Path_560",
  "data-name": "Path 560",
  d: "M318.217,167.5a.415.415,0,0,0,.417-.418v-6.464a.417.417,0,1,0-.833,0v6.464A.415.415,0,0,0,318.217,167.5Z",
  transform: "translate(-308.822 -155.243)",
  fill: "#333333"
})))));

exports.deleteIcon = deleteIcon;

var ellipsis = /*#__PURE__*/_react["default"].createElement("svg", {
  style: {
    margin: "auto",
    background: "rgb(255, 255, 255)",
    display: "block",
    shapeRendering: "auto"
  },
  width: "141px",
  height: "50px",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid"
}, /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "84",
  cy: "50",
  r: "10",
  fill: "#7300a8"
}, /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.3968253968253968s",
  calcMode: "spline",
  keyTimes: "0;1",
  values: "8;0",
  keySplines: "0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "fill",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "discrete",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "#7300a8;#7300a8;#7300a8;#7300a8;#7300a8",
  begin: "0s"
})), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "16",
  cy: "50",
  r: "10",
  fill: "#7300a8"
}, /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;8;8;8",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
})), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "50",
  cy: "50",
  r: "10",
  fill: "#7300a8"
}, /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;8;8;8",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.3968253968253968s"
}), /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.3968253968253968s"
})), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "84",
  cy: "50",
  r: "10",
  fill: "#7300a8"
}, /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;8;8;8",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.7936507936507936s"
}), /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.7936507936507936s"
})), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "16",
  cy: "50",
  r: "10",
  fill: "#7300a8"
}, /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;8;8;8",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-1.1904761904761905s"
}), /*#__PURE__*/_react["default"].createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1.5873015873015872s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-1.1904761904761905s"
})));

exports.ellipsis = ellipsis;

var CloseIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 40 40"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M36.3.6L20 17 3.7.6c-1-1-2.9-.8-3.5.8-.4.8-.2 1.7.4 2.3L17 20 .6 36.3c-1 1-.8 2.9.8 3.5.8.3 1.7.1 2.3-.5L20 23l16.3 16.3c1 1 2.9.8 3.5-.8.3-.8.1-1.7-.5-2.3L23 20 39.4 3.7c1-1 .8-2.9-.8-3.5-.8-.4-1.7-.2-2.3.4z",
  fill: "#727272"
}));

exports.CloseIcon = CloseIcon;